module.exports = __webpack_public_path__ + "components/weather-icon/static/nightpartcloud@2-f0d6f19bfa2219392730e3c1a848ca2d.png";